import {CommonPersonalDevelopmentPdfDataProcessor} from '../export-care-plan-common-personal-development-pdf-data';

export class ReligionSpiritualityPdfDataProcessor extends CommonPersonalDevelopmentPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
